import {
  Box,
  Button,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import {
  getDetailWarranteeSamsungSession,
  modifyWarranteeSamsungSession,
} from "../../../api/ApiWarranteeSamsung";
import { WarranteeSamsungSession } from "../../../model/TblWarranteeSamsung";

const EditView = ({ id, onSearch }: EditViewProps) => {
  const entity = {
    id: 0,
    name: null,
    status: "N",
    quantity: 0,
    quantity_Error: 0,
    quantity_New: 0,
    quantity_Success: 0,
  };
  const statusOption = [
    {
      value: "N",
      label: "New",
    },
    {
      value: "R",
      label: "Running",
    },
    {
      value: "S",
      label: "Success",
    },
  ];

  const handleEditWarranteeSamsung = async (
    dataSubmit: WarranteeSamsungSession
  ) => {
    open();
    await modifyWarranteeSamsungSession(dataSubmit);
    onSearch();
    close();
    modals.closeAll();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<WarranteeSamsungSession>({
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const callApiGetData = async () => {
    open();
    let callapi = await getDetailWarranteeSamsungSession(`?Id=${id}`);
    if (!isNullOrUndefined(callapi) && !isNullOrUndefined(callapi?.data)) {
      const dataApi = callapi?.data;
      if (dataApi != null && !isNullOrUndefined(dataApi)) {
        form.setValues(dataApi);
      }

      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  useEffect(() => {
    callApiGetData();
  }, [id]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={950}
        maw={950}
        mx="auto"
        onSubmit={form.onSubmit((e: WarranteeSamsungSession) => {
          handleEditWarranteeSamsung(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên phiên"}
            placeholder={"Nhập tên"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("name")}
          />
          <Select
            label={"Trạng thái"}
            disabled
            data={statusOption}
            mt="md"
            {...form.getInputProps("status")}
          />
        </Group>

        <Group justify="flex-end" mt="lg">
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <Button
            variant="outline"
            color="black"
            type="button"
            loading={visible}
            onClick={() => modals.closeAll()}
            leftSection={<IconX size={18} />}
          >
            Đóng
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default EditView;

type EditViewProps = {
  id: number;
  onSearch: Function;
};
